import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { formatMoney, getMoneyColorClassName } from '../../../utils/money';
import { MoneyTones } from '../../../constants/money.constants';
import styles from './styles/signed-amount.module.scss';

/**
 * An amount coloured by a SEMANTIC tone the caller passes — owed (red),
 * settled (green) or neutral — never by its sign. Colouring by sign was the
 * defect the Transactions story names: advances arrive positive, so every
 * advance rendered green. Callers get the tone from `toneForLedgerRow(row)` in
 * `utils/money`, so this component, the shared ledger table (whose Amount and
 * Fee cells render it) and the support ticket can never disagree.
 *
 * A placeholder is always neutral: `—` means the value is unknown, and green
 * would be colouring a figure that is not there.
 *
 * Lives in `common/` because two feature folders render it (the support ticket
 * and, through the shared table, Reports and the User page); a component in
 * one feature folder importing from another points the dependency the wrong
 * way.
 *
 * @param {Object} props
 * @param {number | string | null | undefined} props.amount
 * @param {string} [props.tone] a MoneyTones value; defaults to neutral
 * @param {string} [props.placeholder='—']
 */
function SignedAmount({ amount, tone = MoneyTones.NEUTRAL, placeholder = '—' }) {
    const label = formatMoney(amount, undefined, placeholder);
    const toneClass = getMoneyColorClassName(label === placeholder ? MoneyTones.NEUTRAL : tone);
    return (
        <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={`${styles.amount} ${toneClass}`}>
            {label}
        </Text>
    );
}

export default SignedAmount;
